(() => {
  const categories = ['sudaderas', 'jerseis', 'camisetas', 'zippers'];
  const isPack = item => item.properties?._pack_prueba === 'ANITIALS-TEST' && !!item.properties?._anitials_pack_id;
  const category = item => {
    if (!isPack(item)) return null;
    const key = item.properties._anitials_pack_category;
    if (categories.includes(key)) return key;
    return !key && item.properties.Pack === 'Pack de sudaderas ANITIALS' ? 'sudaderas' : null;
  };
  const group = cart => {
    const groups = {};
    for (const item of cart.items || []) {
      const key = category(item);
      if (!key) continue;
      (groups[key] ||= []).push(item);
    }
    return groups;
  };
  const rules = key => window.AnitialsPackRules?.[key] || {minimum:2,tiers:[{minimum:2,percent:15},{minimum:4,percent:20}]};
  const rateFor = (count,key) => count < rules(key).minimum ? 0 : rules(key).tiers.reduce((rate,tier)=>count >= Number(tier.minimum) ? Number(tier.percent) : rate,0);
  const totals = items => {
    const quantity = items.reduce((n, item) => n + item.quantity, 0);
    const rate = rateFor(quantity, category(items[0]));
    const expected = items.reduce((n, item) => n + (item.original_price - Math.round(item.original_price * rate / 100)) * item.quantity, 0);
    const actual = items.reduce((n, item) => n + item.final_line_price, 0);
    return { quantity, rate, expected, actual };
  };
  const codesFor = (cart, configured) => {
    const managed = new Set(Object.values(configured).map(code => code.toLowerCase()));
    const result = (cart.discount_codes || []).map(x => x.code).filter(code => code && !managed.has(code.toLowerCase()));
    for (const [key, items] of Object.entries(group(cart))) {
      if (totals(items).quantity >= rules(key).minimum && configured[key]) result.push(configured[key]);
    }
    return [...new Map(result.map(code => [code.toLowerCase(), code])).values()];
  };
  const verify = cart => {
    if ((cart.items || []).some(item => isPack(item) && !category(item))) return false;
    return Object.values(group(cart)).every(items => {
      const value = totals(items);
      return Number.isSafeInteger(value.actual) && value.actual >= 0 && value.actual <= value.expected;
    });
  };
  window.AnitialsPackPricing = { isPack, category, group, totals, codesFor, verify };
})();
